import TableSearcher from './table-searcher'

export default TableSearcher